import './BubbleShape.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var bubble = '_hctkb34-3-15-1';
export var bubbleBorder = '_hctkb33-3-15-1';
export var bubbleOutline = _7a468({defaultClassName:'_hctkb30-3-15-1',variantClassNames:{active:{true:'_hctkb31-3-15-1',false:'_hctkb32-3-15-1'}},defaultVariants:{},compoundVariants:[]});